
export var cutom_utils = {
  getYears : function(){
    let currentDate = new Date();
    let years = [];

    for (let i = currentDate.getFullYear() - 1; i > currentDate.getFullYear() - 101; i--) {
        years.push(i);
    }
    return years;
  },
  getDate : function(){
    var date = {};
    return date;
  }
}



/** WEBPACK FOOTER **
 ** ./src/ucd_utils/util.js
 **/